import { Component, Input, NgModuleRef, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

import { BcCalendarAddSlot, BcCalendarEvent } from '@bayclubs/calendar';
import { ModalService } from '@bayclubs/utils';

import { GroupClassesSecurityService } from '@infrastructure/infrastructure.module';

import { map } from 'rxjs/operators';
import { GroupClassSaveComponent } from '../../components/group-class-save/group-class-save.component';
import { ClassesCalendarFacade } from './../../+store/classes-calendar.facade';

@Component({
    selector: 'app-classes-calendar',
    templateUrl: './classes-calendar.component.html',
    styleUrls: ['./classes-calendar.component.scss'],
    standalone: false
})
export class ClassesCalendarComponent implements OnInit {
    @Input() clubId: string;

    calendarSettings$ = this.classesCalendarFacade.calendarSettings$;
    calendarEvents$ = this.classesCalendarFacade.calendarEvents$;
    calendarResources$ = this.classesCalendarFacade.calendarResources$;

    constructor(
        private classesCalendarFacade: ClassesCalendarFacade,
        private modalService: ModalService,
        private moduleRef: NgModuleRef<any>,
        private security: GroupClassesSecurityService
    ) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {}

    onEventClicked(event: BcCalendarEvent) {}

    onAddClicked(addSlot: BcCalendarAddSlot) {
        this.canAddEvent().subscribe(canAdd => {
            if (canAdd ) {
                var params = {
                    clubId: this.clubId,
                    timeFromInMinutes: addSlot.timeFromInMinutes,
                    timeToInMinutes: addSlot.timeToInMinutes,
                    date: addSlot.date,
                    locationId: addSlot.resourceId
                };

                this.modalService
                    .create<GroupClassSaveComponent>(GroupClassSaveComponent, params, this.moduleRef)
                    .subscribe(() => {});
            }
        });
    }

    onCancelledClicked(events: BcCalendarEvent[]) {}

    public canAddEvent(): Observable<boolean> {
        return this.security.canManageGroupClasses(this.clubId).pipe(
            map(canManage => {
                return canManage;
            })
        );
    }
}
